<template>
  <!-- FedEx logo supplied by the FedEx Integrator validation team; shown wherever FedEx services are offered -->
  <img :src="logo" alt="FedEx" :style="{ height: `${height}px` }" class="fedex-logo d-inline-block" />
</template>

<script>
import logo from '@/assets/fedex_logo.svg'

export default {
  name: 'FedExLogo',
  props: {
    height: { type: Number, default: 22 },
  },
  data(){
    return { logo }
  },
}
</script>

<style scoped>
.fedex-logo { vertical-align: middle; }
</style>
